module.exports = __webpack_public_path__ + "img/bg.d20bebe5.jpeg";